module.exports = __webpack_public_path__ + "img/book3.403c81e1.jpg";